import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import AppShell from "@/components/AppShell";

import Dashboard from "@/pages/warehouse/Dashboard";
import Inventory from "@/pages/warehouse/Inventory";
import Bins from "@/pages/warehouse/Bins";
import GRN from "@/pages/warehouse/GRN";
import Picking from "@/pages/warehouse/Picking";
import Packing from "@/pages/warehouse/Packing";
import Dispatch from "@/pages/warehouse/Dispatch";
import Transfers from "@/pages/warehouse/Transfers";
import Audit from "@/pages/warehouse/Audit";
import Equipment from "@/pages/warehouse/Equipment";
import Barcode from "@/pages/warehouse/Barcode";

// Reuse shared pages
import AuditLog from "@/pages/settings/AuditLog";
import MfaSettings from "@/pages/settings/Mfa";

export default function WarehouseDashboard() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return (
    <AppShell variant="warehouse">
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/bins" element={<Bins />} />
        <Route path="/grn" element={<GRN />} />
        <Route path="/picking" element={<Picking />} />
        <Route path="/packing" element={<Packing />} />
        <Route path="/dispatch" element={<Dispatch />} />
        <Route path="/transfers" element={<Transfers />} />
        <Route path="/audits" element={<Audit />} />
        <Route path="/equipment" element={<Equipment />} />
        <Route path="/barcode" element={<Barcode />} />
        <Route path="/audit" element={<AuditLog />} />
        <Route path="/settings/mfa" element={<MfaSettings />} />
      </Routes>
    </AppShell>
  );
}
